<script lang="ts">
	import { chatT } from '@repo/commons/i18n/chat'

	interface Props {
		input: string
		rows?: number
		handleKeydown(e: KeyboardEvent): void
	}

	let { input = $bindable(''), rows = 1, handleKeydown }: Props = $props()

	let textareaEl: HTMLTextAreaElement | null = null

	function autoResize() {
		if (textareaEl) {
			textareaEl.style.height = 'auto'
			textareaEl.style.height = textareaEl.scrollHeight + 'px'
		}
	}

	function handleInput() {
		autoResize()
	}

	$effect(() => {
		if (textareaEl && !input) {
			handleInput()
		}
	})

	$effect(() => {
		if (textareaEl) {
			textareaEl?.focus()
		}
	})
</script>

<textarea
	{rows}
	placeholder={$chatT('ChatInput.Placeholder')}
	class="chatInput"
	bind:this={textareaEl}
	bind:value={input}
	oninput={autoResize}
	onkeydown={handleKeydown}
></textarea>

<style lang="postcss">
	.chatInput {
		@apply flex-1 text-base leading-6 text-[#002c4d] bg-transparent border-none outline-none overflow-auto resize-none w-full;
	}
</style>
